<template>
    <div class="replies mb-2">
        <div class="comment panel-card">
            <div class="row no-gutters">
                <div class="comment-avatar col-md-1 col-2 text-center py-1">
                    <span><img class="mx-auto rounded-circle img-fluid" :src="item.img ?  appUrl.media+'/'+item.img :  imageUser" alt="avatar"></span>
                </div>
                <div class="comment-content col-md-11 col-sm-10 rtl text-right">
                    <div class="d-flex flex-md-row flex-column">
                        <h6 class="col-6 small comment-meta mb-0 pt-1">
                            <span class="text-info mb-0">{{item.fullname}}</span>
                            <span class="text-dark mr-1 mb-0 ">{{item.date | date}}</span>
                        </h6>
                        <button v-if="isAdmin" @click="$emit('editReplies')" class="mt-1 mb-1 bttn-material-circle  bttn-md bttn-success flaticon-content mr-auto"  v-ripple :title="'ویرایش سوال'"></button>
                    </div>
                    <div class="col-12 mt-3 comment-body rtl text-rtl">
                        <p>
                            <div v-html="item.content"></div>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'component-replies',
  props: ['item', 'isAdmin'],
  data () {
    return {
      starVal: 4.3
    }
  }
}
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/replies.vue